import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CreateSchool = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to school inquiry form — direct school creation is no longer allowed
    navigate('/school-inquiry', { replace: true });
  }, [navigate]);

  return null;
};

export default CreateSchool;
